var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"featured_article"},[_c('h1',[_vm._v("Page not found.")]),_c('router-link',{staticClass:"cd_btn",attrs:{"to":"/home"}},[_vm._v("Back to Home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }